import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {Modulos} from "src/app/core/modulos";
import {AcessoModuloResolver} from "src/app/guards/acesso-modulo.resolve";
import {AuthGuard} from "src/app/guards/auth.guard";
import {CadastrarRimComponent} from "./cadastrar-rim/cadastrar-rim.component";
import {RimComponent} from "./rim.component";

const routes: Routes = [
    {
        path: "rim/cadastrar",
        component: CadastrarRimComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {modulo: Modulos.RIM},
    },
    {
        path: "rim",
        component: RimComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {modulo: Modulos.RIM},
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class RimRoutingModule {
}
